<div class="signup-form container">
    <form (submit)="submitForm(signInForm)" #signInForm="ngForm">
        <h2>Please Register</h2>
        <div class="form-group">
            <input type="text" class="form-control" [(ngModel)]="user.username" name="username" placeholder="Employee Number" required />
        </div>
        <div class="form-group">
            <input
                type="password"
                class="form-control"
                [(ngModel)]="user.password"
                (ngModelChange)="passwordErrors = []"
                name="password"
                placeholder="Password"
                required
            />
        </div>
        <div class="form-group">
            <input
                type="password"
                class="form-control"
                [(ngModel)]="user.confirmPassword"
                name="confirmPassword"
                placeholder="Confirm Password"
                required
            />
        </div>
        <div class="form-group">
            <button type="submit" class="btn btn-success btn-lg btn-block" [disabled]="isInvalid || isSigningIn">
                <span *ngIf="isSigningIn"><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Registering</span>
                <span *ngIf="!isSigningIn">Register</span>
            </button>
        </div>
        <div>
            <span class="reg-error">{{ passwordMismatch }}</span>
            <div class="reg-error" *ngFor="let error of passwordErrors">{{ error }}</div>
        </div>
    </form>
    <div class="text-center">Already Registered? <a style="cursor: pointer" (click)="signin()">Sign In</a></div>
</div>
